import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import DestinationActions from '../../Redux/DestinationRedux'
import FilesActions from '../../Redux/FilesRedux'
import findKey from 'lodash/findKey'
import FileUploader from '../FileUploader'
import Immutable from 'seamless-immutable'
import ObjectCleaner from '../../Utils/ObjectCleaner'

class FormEdit extends React.Component {
  constructor (props) {
    super (props)

    this.lang = ['en', 'id']

    const { country_list } = props
    let countries = []
    country_list.map((item, i) => {
      countries[i] = {
        value: item.id,
        label: item.name
      }
      return countries
    })

    this.countries = countries

    const key = findKey(countries, ['value', props.data.country_id])
    const { about } = props.data

    let aboutValues = {}
    this.lang.forEach((lang) => {
      let getting_around = []
      let weather = []
      let currency = []
      let health = []
      if (about[lang] && about[lang].getting_around) {
        about[lang].getting_around.forEach((data) => getting_around.push(Immutable(data).asMutable()))
      }
      if (about[lang] && about[lang].weather) {
        about[lang].weather.forEach((data) => weather.push(Immutable(data).asMutable()))
      }
      if (about[lang] && about[lang].currency) {
        about[lang].currency.forEach((data) => currency.push(Immutable(data).asMutable()))
      }
      if (about[lang] && about[lang].health) {
        about[lang].health.forEach((data) => health.push(Immutable(data).asMutable()))
      }
      
      aboutValues[lang] = {
        getting_around,
        weather,
        currency,
        health
      }
    })

    this.state = {
      name: props.data.name || '',
      experience_count: props.data.experience_count || 0,
      priority: props.data.priority || 1,
      country: countries[key] || '',
      selected: {
        wide: props.data.image_file.wide || '',
        narrow: props.data.image_file.narrow || '',
        wide_mobile: props.data.image_file.wide_mobile || ''
      },
      files: [],
      uploaded: false,
      lang_tab: this.lang[0],
      about: aboutValues
    }
  }

  // _fileSelect = (event) => {
  //   let files = []
  //   const raw = event.target.files
  //   for(let i = 0; i < raw.length; i++) {
  //     files.push(raw[i])
  //   }
  //   this.setState({ files })
  // }

  _fileUploaded = (filename, field) => {
    let selected = {...this.state.selected}
    selected[field] = filename
    this.setState({selected})
  }

  // _upload = (event) => {
  //   event.preventDefault()
  //   let data = new FormData(event.target)
  //   data.append('type', 'destination-image')
    
  //   this.props.upload(data)
  //   this.setState({ uploaded: true })
  // }

  // _imgSelect = (event, field) => {
  //   let newState = {...this.state.selected}
  //   newState[field] = event.target.value
  //   this.setState({selected: newState})
  // }

  _inputChange = (event, field) => {
    let newState = {...this.state}
    newState[field] = event.target.value
    this.setState(newState)
  }

  _submit = (event) => {
    event.preventDefault()

    let image_file = {
      wide: this.state.selected.wide,
      narrow: this.state.selected.narrow,
      wide_mobile: this.state.selected.wide_mobile
    }

    image_file = ObjectCleaner(image_file)

    const content = {
      name: this.state.name,
      experience_count: this.state.experience_count,
      priority: this.state.priority,
      country_id: this.state.country.value,
      image_file,
      about: this.state.about
    }

    this.props.submit(this.props.data.id, content)
    this.props.closeModal()
  }

  _addItem = (field) => {
    let about = {...this.state.about}
    about[this.state.lang_tab][field].push({ title: '', content: '' })

    this.setState({ about })
  }
  
  _removeItem = (field, index) => {
    let about = {...this.state.about}
    about[this.state.lang_tab][field].splice(index, 1)

    this.setState({ about })
  }

  _aboutChange = (event, parentField, index, field) => {
    let val = event.target.value
    let about = {...this.state.about}

    about[this.state.lang_tab][parentField][index][field] = val
    this.setState({ about })
  }


  render() {
    const { data, editType, closeModal } = this.props

    const aboutList = [
      { id: 'getting_around', label: 'Getting Around' },
      { id: 'weather', label: 'Weather' },
      { id: 'currency', label: 'Currency and Tipping' },
      { id: 'health', label: 'Health' },
    ]

    // const Update = () => {
    //   return <div className="alert alert-info">Updating ...</div>
    // }

    // const Success = () => {
    //   setTimeout(() => this.props.closeModal(), 10)
    //   return <div className="alert alert-success">Updated successfuly!</div>
    // }

    // const Error = () => {
    //   return <div className="alert alert-danger">{ this.props.error }</div>
    // }

    return (
      <div className="section" style={{ width: '45vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Edit Destination</h4>
        </div>
        {/* {this.props.processing && <Update/>}
        {this.props.success && <Success/>}
        {this.props.error && <Error/>} */}
        { editType === 'edit-content' ?
          <form onSubmit={(event) => this._submit(event)}>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="name" className="control-label">Name</label>
              </div>
              <div className="col-9">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  onChange={(event) => this._inputChange(event, 'name')}
                  value={this.state.name}
                  placeholder="Destination Name"
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="experience_count" className="control-label">Experience Count</label>
              </div>
              <div className="col-9">
                <input
                  type="number"
                  name="experience_count"
                  min={0}
                  className="form-control"
                  onChange={(event) => this._inputChange(event, 'experience_count')}
                  value={this.state.experience_count}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="priority" className="control-label">Priority</label>
              </div>
              <div className="col-9">
                <input
                  type="number"
                  name="priority"
                  min={1}
                  className="form-control"
                  onChange={(event) => this._inputChange(event, 'priority')}
                  value={this.state.priority}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="country" className="control-label">Country</label>
              </div>
              <div className="col-9">
                <Select options={this.countries} value={this.state.country} onChange={(country) => this.setState({ country })}/>
              </div>
            </div>
            <div className="about-list-container">
              <div className="btn-group mb-4" role="group">
                {
                  this.lang.map((lang, i) => (
                    <button
                      key={i}
                      type="button"
                      className={`btn btn-primary ${(this.state.lang_tab === lang) && 'active'}`}
                      onClick={() => this.setState({ lang_tab: lang })}
                    >
                      { lang.toUpperCase() }
                    </button>
                  ))
                }
              </div>
              {aboutList.map((about) => (
                <div key={about.id} className="about-list">
                  <div className="control-label d-flex justify-content-between" style={{width: '100%'}}>
                    <h6 className="title">{about.label || '-'}  [ {this.state.lang_tab.toUpperCase()} ]</h6>
                    <button type="button" className="btn btn-primary" onClick={() => this._addItem(about.id)}>Add Item</button>
                  </div>
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Content</th>
                        <th width="15%" className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.about[this.state.lang_tab][about.id].length ? 
                        this.state.about[this.state.lang_tab][about.id].map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <input required type="text" value={item.title} className="form-control" onChange={(e) => this._aboutChange(e, about.id, i, 'title')}/>
                              </td>
                              <td>
                                <textarea required value={item.content} className="form-control" onChange={(e) => this._aboutChange(e, about.id, i, 'content')}/>
                              </td>
                              <td className="text-center">
                                <button type="button" className="btn btn-danger" onClick={() => this._removeItem(about.id, i)}>
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          )
                        })
                        :
                        <tr>
                          <td colSpan="3" className="text-center">- No Data -</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              ))}
            </div>

            <div className="form-group d-flex justify-content-end mt-2">
              <button className="btn btn-lg btn-secondary mr-2" onClick={() => closeModal()}>Close</button>
              <button className="btn btn-lg btn-primary" type="submit">Save</button>
            </div>
          </form>
          :
          // EDIT IMAGE
          <form onSubmit={(event) => this._submit(event)}>
            <div className="form-group row">
              <div className="col-3">
                <label className="control-label">Name</label>
              </div>
              <div className="col-9">
                <em>{data.name}</em>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label className="control-label">Image Narrow (<span className="text-orange">270x200</span>)</label>
              </div>
              <div className="col-9">
                <FileUploader setting={{ type: 'destination-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'narrow')}/>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label className="control-label">Image Wide (<span className="text-orange">1440x277</span>)</label>
              </div>
              <div className="col-9">
                <FileUploader setting={{ type: 'destination-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'wide')}/>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label className="control-label">Image Wide Mobile (<span className="text-orange">375x269</span>)</label>
              </div>
              <div className="col-9">
                <FileUploader setting={{ type: 'destination-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'wide_mobile')}/>
              </div>
            </div>
            <div className="form-group d-flex justify-content-end">
              <button className="btn btn-lg btn-secondary mr-2" onClick={() => closeModal()}>Close</button>
              <button className="btn btn-lg btn-primary" type="submit">Save</button>
            </div>
          </form>
        }
      </div>
    )
  }
}

const stateToProps = (state) => ({
  uploadFiles: state.files,
  processing: state.destination.processing,
  success: state.destination.success,
  error: state.destination.err,
  country_list: state.preset.dataCountries
})

const dispatchToProps = (dispatch) => ({
  submit: (id, content) => dispatch(DestinationActions.destinationUpdateRequest({id, content})),
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
})

export default connect(stateToProps, dispatchToProps)(FormEdit)



// WEBPACK FOOTER //
// ./src/Containers/Destination/FormEdit.js